import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PMSTaskRequest } from '../models/PMSTaskRequest';
@Injectable({
  providedIn: 'root'
})

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  pMSTaskRequest: PMSTaskRequest;
  pmsInfoGroupId = 24;
  constructor(private http: HttpClient) { }

  handleError(error: any): void {
    // Example: Sending the error to a remote server
    this.logErrorToServer(error);
  }

  private logErrorToServer(error: any): void {
    this.pMSTaskRequest = {
      ticketTypeId: 1,
      name: " => Error Happening => ",
      description: error.toString()
    };

    // this.http
    //   .post(
    //     URL.BASE_URL + jhcassoAPIUri.pmsTaskUri,
    //     this.pMSTaskRequest
    //   ).subscribe({
    //     error: err => {
    //       console.error('API Error:', err);

    //       const msg =
    //         err?.error?.message ||
    //         err?.message ||
    //         'Unknown server error';

    //       alert('Error logging failed: ' + msg);
    //     }
    //   });
  }
}
